/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * GoogleWhiteCircleIcon - Auto-generated from icon.js
 */
export const GoogleWhiteCircleIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
		<path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47667 2 2 6.4775 2 12C2 17.5225 6.47667 22 12 22C17.5225 22 22 17.5225 22 12C22 6.4775 17.5225 2 12 2ZM12.1167 17.8483C8.89333 17.8483 6.28333 15.2317 6.28333 12C6.28333 8.76833 8.89333 6.15167 12.1167 6.15167C13.6917 6.15167 15.0083 6.7325 16.0183 7.67583L14.3733 9.32417V9.32083C13.7608 8.73583 12.9842 8.43583 12.1167 8.43583C10.1917 8.43583 8.6275 10.0658 8.6275 11.9967C8.6275 13.9258 10.1917 15.5608 12.1167 15.5608C13.8633 15.5608 15.0517 14.5592 15.2967 13.1842H12.1167V10.9033H17.6042C17.6775 11.295 17.7167 11.7033 17.7167 12.1317C17.7167 15.4733 15.4858 17.8483 12.1167 17.8483Z" fill="white" />
	</svg>
);

export default GoogleWhiteCircleIcon;
